// extracted by mini-css-extract-plugin
module.exports = {"container":"az_uWb","imageContainer":"az_vWb","image":"az_wWb","heading":"az_xWb","description":"az_yWb"};